import { useFetchCallback } from '@services/services';
import { useIntegrationsActions, useIntegrationsFromStore } from '@store/actions/integrations';
import { Integration } from '@utils/constants';
import { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast';

export const useGetIntegrations = () => {
  const integrations = useIntegrationsFromStore();
  const { initIntegrations } = useIntegrationsActions();
  const { call, isFetching } = useFetchCallback<Integration[]>('get', '/v1/integrations');

  const refreshIntegrations = useCallback(async () => {
    try {
      const data = await call();
      initIntegrations(data);
    } catch (error) {
      toast.error('Error al obtener las integraciones');
    }
  }, [call, initIntegrations]);

  useEffect(() => {
    if (!integrations.length) {
      refreshIntegrations();
    }
  }, []);

  return {
    integrations,
    isFetching,
    refreshIntegrations,
  };
};
